import { DvfField, DvfGeometry } from './dvfField';

export function dvfGeometriesMatch(fields: DvfField[]): boolean {
    if (fields.length < 2) {
        return true;
    }
    const [a] = fields;
    const eq3 = (u: readonly number[], v: readonly number[]) =>
        u[0] === v[0] && u[1] === v[1] && u[2] === v[2];
    return fields.every(
        (f) =>
            eq3(f.size, a.size) &&
            eq3(f.spacing, a.spacing) &&
            eq3(f.origin, a.origin)
    );
}

export function computeDvfUncertainty(fields: DvfField[]): {
    values: Float32Array;
    max: number;
    geometry: DvfGeometry;
} {
    const [first] = fields;
    const [nx, ny, nz] = first.size;
    const nVox = nx * ny * nz;
    const values = new Float32Array(nVox);
    const n = fields.length;
    let max = 0;
    for (let v = 0; v < nVox; v++) {
        const base = v * 3;
        let mx = 0;
        let my = 0;
        let mz = 0;
        for (let s = 0; s < n; s++) {
            const d = fields[s].data;
            mx += d[base];
            my += d[base + 1];
            mz += d[base + 2];
        }
        mx /= n;
        my /= n;
        mz /= n;
        let spread = 0;
        for (let s = 0; s < n; s++) {
            const d = fields[s].data;
            spread += Math.hypot(
                d[base] - mx,
                d[base + 1] - my,
                d[base + 2] - mz
            );
        }
        spread /= n;
        values[v] = spread;
        if (spread > max) {
            max = spread;
        }
    }
    return { values, max, geometry: first };
}
